var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBolt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.647 10.147a.75.75 0 0 0 .644.883l4.938.617c.082.019.128.069.15.134a.22.22 0 0 1-.043.217L8.55 23.163a.25.25 0 0 1-.145.084c-.045.008-.1 0-.153-.027a.26.26 0 0 1-.115-.111.28.28 0 0 1-.02-.18l2.27-8.942a.75.75 0 0 0-.574-.919l-4.924-1.026a.21.21 0 0 1-.13-.14c-.022-.078 0-.136.023-.163l.004-.005L13.958.838l.006-.008a.2.2 0 0 1 .116-.076.25.25 0 0 1 .147.02.26.26 0 0 1 .116.097c.017.027.03.065.024.125z"
})));
export default SvgBolt;